import { render, staticRenderFns } from "./InputSubmission.vue?vue&type=template&id=c150de4a&"
import script from "./InputSubmission.vue?vue&type=script&lang=js&"
export * from "./InputSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports